import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import {et} from "../data/energyTypes";
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import Country from "../classes/Country";
import Select from "react-select";


export interface diagProps {
	owner: object;
	onClose: (value: string) => void;
}

const { Formik } = formik;

const states = [
	{label:'Terminated', value:'Terminated'},
	{label:'On Hold', value:'On Hold'},
];

var  projectCountries = null;
const phaseOpts		= projectPhaseColors.asOpts();
const statusOpts		= projectStatusColors.asOpts();

class DialogSettings extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		projectCountries = [{label:'All', value:'All'}, ...Country.options]
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};
	handleUpdateUser(data){
		
		var newuser = {...this.props.user, ...{settings:data.settings}};
		this.props.onUpdateUser(newuser);
		
	};
	handleSubmit(data){

		
		this.updateStatus({sent:false, success:false, message:'Updating settings...'});
		//saveguard for testing
		
		
		if(data.ts && data.ts.circles){
			data.turbineStyles = {}
			data.turbineStyles.circles = data.ts.circles.length;
			
			delete data.ts;
		}
		
		var data = {settings:data,
			email: this.props.user.userDetails,
		}

		
		//console.log(setMainScenario);
		atlasApi.updateSettings(data).then((response)=>{
			if(response.success){
				this.updateStatus({sent:true, success:true, message:'Settings updating'});
				setTimeout(()=>this.handleClose(), 2000);
				
				this.handleUpdateUser(data);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error updating settings'});
			
			
			
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error updating settings'});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};


	render() {
		return (
			<Modal show={this.props.setup.open} size="lg" onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Account settings</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.settings} onSubmit={this.handleSubmit.bind(this)} initialValues={this.props.user.settings}>	
					{({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<Row className="mb-3">
											<Form.Group as={Col} md="6" controlId="validationFormik01">
												<Form.Label>First Name</Form.Label>
												<Form.Control type="text" name="firstName" placeholder="First Name" value={values.firstName } onChange={handleChange} isValid={touched.firstName && !errors.firstName} isInvalid={errors.firstName}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid  first name.
												</Form.Control.Feedback>
											</Form.Group>
											<Form.Group as={Col} md="6" controlId="validationFormik00">
												<Form.Label>Last Name</Form.Label>
												<Form.Control type="text" name="lastName" placeholder="Last Name" value={values.lastName } onChange={handleChange} isValid={touched.lastName && !errors.lastName} isInvalid={errors.lastName}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid last name.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										
										
										<Row className="my-3">
											<b>Map settings</b>
										</Row>
										<Form.Group as={Col} md="12" controlId="validationFormik01">
											<Form.Check inline label="hectare" value="hectare" name="areaUnit" type="radio" onChange={handleChange} defaultChecked={values.areaUnit === 'hectare'} />
											<Form.Check inline label="meter/kilometer" value="meter" name="areaUnit" type="radio" onChange={handleChange} defaultChecked={values.areaUnit === 'meter'} />
										</Form.Group>
										
										
										<Row className="mt-4">
										
											<Form.Control.Feedback>
											</Form.Control.Feedback>
										</Row>
									</Modal.Body>
									
									<Modal.Footer>
										<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
										<Button variant="success" type="submit">Save settings</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogSettings;